// extracted by mini-css-extract-plugin
export default {"blog_desc":"pages_blog_desc__5h+Z7","blog_title":"pages_blog_title__8rD5C","label":"pages_label__2m7os"};